<template>
  <modal
    name="recotized-limits-modal"
    :scrollable="true"
    :max-width="1000"
    width="35%"
    height="auto"
    @before-close="beforeClose">
    <div class="reference-modal" style="padding: 20px;">
      <div
        class="reference-modal-bar"
        style="color: #50bfa3; border-bottom: 1px solid #e1e1e1; text-align: right;">
        <i
          class="material-icons reference-modal-close"
          @click="$modal.hide('recotized-limits-modal')">highlight_off</i>
      </div>
      <div class="reference-modal-header">
        <h3>Atención</h3>
      </div>
      <hr>
      <div>
        <p>La formula recotizada no cumple con alguno de los límites de inclusión de ingredientes. Por favor vuelve a formularla.</p>
      </div>
      <div class="reference-modal__btns">
        <span
          class="btn"
          @click="$modal.hide('recotized-limits-modal')">Entendido</span>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ModalRecotizedLimits',
  methods: {
    beforeClose() {
      window.location.href = '/';
    },
  },
};
</script>
